<div class="sidebar">
  <div class="order-test" *ngIf="isShowAddCart">
    <div>
      <h4 class="order-test-title">Order {{ medicalTest ? 'Test' : 'Drug' }}</h4>
      <div class="p-2">
        <p>
          {{ cartItems | addToCartText: medicalTest || drug }}
        </p>
        <div class="add-cart-buttons">
          <button 
            class="sigma_btn btn-sm mb-3" 
            (click)="addToCart(medicalTest || drug, selectedQuantity)" 
            [disabled]="selectedQuantity?.is_in_stock === 0"
            [ngClass]="{
              'btn-remove': ({ cartItems } | buttonText: drug || medicalTest) === 'Remove',
              'btn-update': !medicalTest && 
                            ({ cartItems, isDrugUpdate: isUpdate[drug.id] } | buttonText: drug) === 'Update Cart'
            }"
          >
            {{ medicalTest ? 
              ({ cartItems } | buttonText: medicalTest)  : 
              ({cartItems, isDrugUpdate: isUpdate[drug.id]} | buttonText: drug) }}
          </button>
        </div>
        <p *ngIf="selectedQuantity?.is_in_stock === 0" class="text-danger">Out of stock</p>
      </div>
    </div>
  </div>
  <!-- TODO: come up with a better solution that doesn't involve writing the title like this -->
  <div *ngIf="otherService?.title == 'Ask The Doctor'" class="medical-consultation">
    <app-medical-consultation></app-medical-consultation>
  </div>

  <div *ngIf="otherService?.title == 'Order For Drugs'" class="medical-consultation">
    <app-upload-prescription></app-upload-prescription>
  </div>
  <!-- Follow Widget -->
  <!-- TODO: decide if still needed -->
  <!-- <div class="widget widget-follow">
    <h5 class="widget-title">Follow Us</h5>
    <div class="social-buttons">
      <a href="#" class="btn-block sigma_btn">
        <div class="follow-icon d-flex align-items-center">
          <i class="fab fa-instagram"></i>
          <p class="mb-0">
            Instagram
            <span>225.5k Followers</span>
          </p>
        </div>
        <i class="fal fa-chevron-right"></i>
      </a>
      <a href="#" class="btn-block sigma_btn">
        <div class="follow-icon d-flex align-items-center">
          <i class="fab fa-twitter"></i>
          <p class="mb-0">
            Twitter
            <span>225.5k Followers</span>
          </p>
        </div>
        <i class="fal fa-chevron-right"></i>
      </a>
      <a href="#" class="btn-block sigma_btn">
        <div class="follow-icon d-flex align-items-center">
          <i class="fab fa-facebook-f"></i>
          <p class="mb-0">
            Facebook
            <span>225.5k Followers</span>
          </p>
        </div>
        <i class="fal fa-chevron-right"></i>
      </a>
      <a href="#" class="btn-block sigma_btn">
        <div class="follow-icon d-flex align-items-center">
          <i class="fab fa-youtube"></i>
          <p class="mb-0">
            Youtube
            <span>225.5k Followers</span>
          </p>
        </div>
        <i class="fal fa-chevron-right"></i>
      </a>
    </div>
  </div> -->
  <!-- <div class="widget widget-blockquote p-0 border-0">
    <blockquote class="blockquote">
      <cite>Request a Quote</cite>
      <p>Cras ultricies ligula sed magna dictum porta. Vivamus suscipit tortor eget felis porttitor volutpat.</p>
      <a 
        routerLink="/contact" 
        [state]="{ data: medicalTest ? medicalTest.name : otherService.title }" 
        class="sigma_btn btn-sm">
        Request Quote
      </a>
    </blockquote>
  </div> -->
  <!-- TODO: look for another solution to handle this so that we don't have to write the title directly -->
  <div 
    class="widget widget-blockquote p-0 border-0" 
    *ngIf="otherService?.title && otherService?.title !== 'Ask The Doctor' && otherService?.title !== 'Order For Drugs'"
  >
    <blockquote class="blockquote">
      <cite>Request more information</cite>
      <p>
        {{ otherService?.title === 'Home Doctor Visit' ? 'Request for a private home doctor visit.' :
           otherService?.title === 'Request a Lab Test' ? 'Order a medical test online.' : '' }}
      </p>
      
      <a 
        *ngIf="otherService?.title !== 'Order For Drugs'"
        [routerLink]="otherService?.title === 'Request a Lab Test' ? '/medical-tests' : '/contact'"
        [state]="{ data: medicalTest ? medicalTest.name : otherService?.title }"
        class="sigma_btn btn-sm">
        {{ otherService?.title === 'Home Doctor Visit' ? 'Request visit' :
           otherService?.title === 'Request a Lab Test' ? 'Order Test' :
           'Request Quote' }}
      </a>
  
    </blockquote>
  </div>  
  <!-- Category Widget -->
  <div class="widget widget-categories">
    <h5 class="widget-title">Categories</h5>
    <ul class="categories-list">
      <ng-container *ngIf="drug">
        <li *ngFor="let item of drugCategories | slice:0:4; let i = index;" class="category-item">
          <a (click)="filterProducts({ category: item.title }, 'drugs')" class="category-link">
            {{ item.title }}
          </a><span>{{ categoryCounts[item.title] || 0 }}</span>
        </li>
      </ng-container>
      <ng-container *ngIf="!drug">
        <li *ngFor="let item of medicalTestCategories | slice:0:4; let i = index;" class="category-item">
          <a (click)="filterProducts({ category: item.title }, 'medicalTests')" class="category-link">
            {{ item.title }}
          </a><span>{{ categoryCounts[item.title] || 0 }}</span>
        </li>
      </ng-container>
      
    </ul>    
  </div>
  <!-- Subscribe Widget -->
  <!-- TODO: find out if newsletters will be used -->
  <!-- <div class="widget widget-newsletter">
    <h5 class="widget-title">Join Newsletter</h5>
    <form>
      <input type="email" name="email" placeholder="Enter your email" required>
      <button type="button" class="btn-block mt-4">Subscribe</button>
    </form>
  </div> -->
</div>
